import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, Card } from '@material-ui/core';
import { Modal } from 'antd';
import MainContainer from '../../../components/MainContainer';
import FnbAdditionalItemListPage from './FnbAdditionalItemList';
import FnbAdditionalItemModalPage from './FnbAdditionalItemModal';
import FnbAdditionalItemSearchModal from './FnbAdditionalItemSearchModal';
import './FnbAdditionalItem.css';

@inject(
    'loginStore',
    'FnbAdditionalItemStore'
)
@observer
class FnbAdditionalItemPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        this.props.loginStore.authenticateAdmin().then(response => {
          if (!response) {
            this.props.history.push('/admin/login');
          }
        });
    }

    // ON CANCEL

    fnbAdditionalItemModalOnCancel = () => {
        this.props.FnbAdditionalItemStore.setShowFnbAdditionalItemModal(false);
    }

    fnbAdditionalItemSearchModalOnCancel = () => {
        this.props.FnbAdditionalItemStore.setShowFnbAdditinalItemSearchModal(false);
    }

    render() {
        const {
            showFnbAdditionalItemModal,
            fnbAdditionalItemTitle,
            showFnbAdditinalItemSearchModal
        } = this.props.FnbAdditionalItemStore;

        return (
            <MainContainer title='In Room Dining Additional Item' menukey='fnb-additional-item'>
                <Modal
                    title={fnbAdditionalItemTitle}
                    visible={showFnbAdditionalItemModal}
                    width={800}
                    footer={null}
                    onCancel={this.fnbAdditionalItemModalOnCancel}
                    zIndex={1000}
                >
                    <FnbAdditionalItemModalPage />
                </Modal>

                <Modal
                    title="Search In Room Dining"
                    visible={showFnbAdditinalItemSearchModal}
                    width={800}
                    footer={null}
                    onCancel={this.fnbAdditionalItemSearchModalOnCancel}
                    zIndex={2000}
                >
                    <FnbAdditionalItemSearchModal />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: 'auto' }}>
                            <FnbAdditionalItemListPage />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default FnbAdditionalItemPage;